import {
  Column,
  Copy,
  Flex,
  Heading,
  Row,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import {
  getInfo,
  IMealCredit,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { RouterLink } from 'src/components/RouterLink/RouterLink';
import { MealCreditDurationsSummary } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/MealCreditDurationsSummary';

interface MealCreditDetailsSectionProps {
  mealCredit: IMealCredit;
  corpId: string;
}

export function MealCreditDetailsSection({
  mealCredit,
  corpId,
}: MealCreditDetailsSectionProps): JSX.Element {
  const { corpData } = useAuth();
  return (
    <>
      <Square inset="lg" bg="globals.white" dimension="2">
        <Row>
          <Column phone={4}>
            <Heading variant="h6">{mealCredit.name}</Heading>
          </Column>
          <Column phone={6}>
            <MealCreditDurationsSummary mealCredit={mealCredit} />
          </Column>
          <Column phone={2}>
            <Flex justifyContent="flex-end" alignItems="center">
              <RouterLink
                href={`/corporate/enterprise/${corpId}/meal-credits/${mealCredit.id}/edit`}
              >
                Edit details
              </RouterLink>
            </Flex>
          </Column>
        </Row>
      </Square>
      <Square inset="lg" bg="globals.white" dimension="2">
        <Row>
          {getInfo(mealCredit, corpData).map(({ label, value }) => (
            <Column key={label} phone={4}>
              <Stack y="sm">
                <Flex aria-label={label} flexDirection="column">
                  <Copy variant="caption" color="secondaryText">
                    {label}
                  </Copy>
                  <Copy variant="body">{value}</Copy>
                </Flex>
              </Stack>
            </Column>
          ))}
        </Row>
      </Square>
    </>
  );
}
